<script lang="ts">
  import Routes from '$provider/constants/Route';

  interface Props {
    orgName?: string;
  }

  let { orgName = 'Organisation Name' }: Props = $props();
</script>

<div class="cred-auth-banner">
  <div class="content">
    <span class="label">Credentialing Ops</span>
    <span class="orgName">Logged in as <b>{orgName}</b></span>
    <a href={Routes.ChangeOrg}>(Change)</a>
  </div>
</div>

<style>
  .cred-auth-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 16px;
    font-weight: 500;
    font-size: 10px;
    width: 100%;
    height: 20px;
    background-color: var(--light-blue);
    color: var(--blue);
  }
  .content {
    display: flex;
  }
  .content .label {
    margin-right: 8px;
  }
  .content a {
    color: inherit;
  }
  .content .orgName {
    margin-right: 8px;
    padding-left: 8px;
    position: relative;
  }
  .content .orgName::before {
    content: '';
    width: 4px;
    height: 4px;
    background-color: var(--blue);
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translate(0, -50%);
  }
</style>
